// extracted by mini-css-extract-plugin
module.exports = {"title":"product_title__06CR5","badge":"product_badge__ZD_G4","badgeCard":"product_badgeCard__AES9e"};